import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { AsyncContent } from '~/components/AsyncContent';
import { People } from '~/services/Http';

import { AbsencesCalendar } from './components/AbsencesCalendar';
import { useSxStyles } from './useStyles';

export interface Props {
  teamAbsencesLoading: boolean;
  failedToLoadTeamAbsences: boolean;
  teamAbsences: People.AbsenceDto[];
  publicHolidays?: People.PublicHolidayDto[];
  containerWidth: number;
  shouldRedirect: boolean;
}

export const Content: React.FC<Props> = ({
  teamAbsencesLoading,
  failedToLoadTeamAbsences,
  teamAbsences,
  publicHolidays,
  containerWidth,
  shouldRedirect,
}) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <AsyncContent
      isLoading={teamAbsencesLoading}
      failedToLoad={failedToLoadTeamAbsences}
      noData={!teamAbsences.length}
      noDataMessage={t('absencesEmpty')}
      customSxStyles={{ errorMessage: sxStyles.errorMessage }}
    >
      <AbsencesCalendar
        teamAbsences={teamAbsences}
        publicHolidays={publicHolidays}
        containerWidth={containerWidth}
        shouldRedirect={shouldRedirect}
      />
    </AsyncContent>
  );
};
